export default __webpack_public_path__ + "static/media/notification.d7f6f5a4.svg";